import { useContext } from 'react';

import configContext from '../config-context';

const DEV = 'development';
const PROD = 'production';
const STAG = 'staging';

export const useEnvironment = () => {
  const { environment } = useContext(configContext);
  return {
    isDev: environment === DEV,
    isStag: environment === STAG,
    isProd: environment === PROD,
  };
};

export const useSite = () => {
  const { site } = useContext(configContext);
  return site;
};

export const useLanguage = () => {
  const { language } = useContext(configContext);
  return language;
};

export const useConfig = () => useContext(configContext);
